(function($) {
    // toggles
    $(document).on('change', '[name="deko[]"]', function(e) {
        if (e.target.checked) {
            $('[name="service[]"]', $(e.target).closest('fieldset')).prop('disabled', false);
        } else {
            $('[name="service[]"]', $(e.target).closest('fieldset')).prop('checked', false);
            $('[name="service[]"]', $(e.target).closest('fieldset')).prop('disabled', true);
        }
    });


    // upload
    $('input[type=file]', '.gal-form-order-service').on('change', prepareUpload);


    function prepareUpload(event) {
        var $form = $(event.target).closest('form');
        $form.find(".btn[type=submit]").prop("disabled", true);

        $('.is-invalid', $form).removeClass('is-invalid');
        $('.alert', $form).prop('hidden', true);
        $('.alert', $form).find('.text').html("");

        var file = event.target.files;
        var data = new FormData();
        data.append("action", "bpmorderuploadservice");
        data.append("email", $(event.target).closest('form').find('[name=email]').val());
        data.append("company", $(event.target).closest('form').find('[name=company]').val());
        data.append("terms", String($(event.target).closest('form').find('[name=terms]').prop('checked')) === 'true');
        data.append("captcha", $(event.target).closest('form').find('[name=captcha]').val());
        data.append("c_img", $(event.target).closest('form').find('[name=c_img]').val());
        data.append('_wpnonce', $(event.target).closest('form').find('[name="_wpnonce"]').val());
        data.append('_wp_http_referer', $(event.target).closest('form').find('[name="_wp_http_referer"]').val());
        data.append('nonce_in', bpm_gal_order_service_data.nonce_in);
        data.append('amount', $(event.target).closest('form').find('[name="upload"]').length);
        $.each(file, function (key, value) {
            data.append("attachment_upload", value);
        });
        // console.log(data);

        $.ajax({
            url: bpm_gal_order_service_data.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (json, textStatus, jqXHR) {
                // console.log(json);
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback, .invalid-tooltip')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_gal_order_service_data.errorStandard;
                    }
                } else {
                    var filePreviewWrapper = $('<div />', { class: 'col-6 col-sm-4 col-md-3 col-lg-5 col-xl-4 col_preview' });

                    var inputFile = $('<input />', { type: 'hidden', name: 'upload', value: json.file.dl_token });

                    var filenameTag = $('<div />', {
                        class: 'file-filename text-truncate',
                        title: json.file.name
                    }).html(json.file.name);

                    var filetypeTag = $('<div />', { class: 'file-type mt-2 text-uppercase fw-bold' }).html(json.file.type.split('/').pop());

                    var iconDiv = $('<div />', { class: 'w-25 mx-auto mb-2'})
                        .html('<svg fill="currentColor" viewBox="0 0 384 512"><path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/></svg>');
                    var linkTo = $('<a />', {
                        class: 'd-block position-relative mb-3 text-decoration-none text-white bg-secondary pb-1 pt-2 px-2 text-center',
                        href: json.file.url,
                        download: json.file.name,
                        target: '_blank',
                        title: json.file.name
                    });

                    linkTo.append(iconDiv)
                        .append(filenameTag)
                        .append(filetypeTag);

                    filePreviewWrapper.append(linkTo)
                        .append(inputFile);

                    $(event.target).closest('form')
                        .find('.row-uploads')
                        .append(filePreviewWrapper);

                    // messageTxt = json.message;
                }

                if (messageTxt.trim() != "") {
                    $form.find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }
            },
            error: function(jqXHR, textStatus) {
                console.log(jqXHR, textStatus);
            },
            complete: function() {
                $form.find(".btn[type=submit]").prop("disabled", false);
            }
        });
        return false;
    }


    // submit
    $("form[name='form-order-service']").on("submit", function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectformorderservice" });
        data.push({ name: "nonce_in", value: bpm_gal_order_service_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $form.find(".btn-upload").prop("disabled", true).addClass('disabled');
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        var dekos = [];
        var services = [];
        data.forEach(function(x) { 
            if (x.name === 'service[]') {
                services.push(x.value);
                return
            }
            if (x.name === 'deko[]') {
                dekos.push(x.value);
                return
            }
            post[x.name] = x.value;
        });
        post.dekos = dekos;
        post.services = services;

        // console.log(post);

        $.ajax({
            url: bpm_gal_order_service_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.form-group')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback, .invalid-tooltip')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_gal_order_service_data.errorStandard;
                    }

                } else {
                    $form[0].reset();
                    $form.find('.row-uploads').html("");
                    $(".form-group-captcha", $form).addClass("d-none").removeClass('d-block');
                    $form.find(".btn-upload").prop("disabled", true).addClass('disabled');
                    messageTxt = json.message || "";

                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                if (typeof _paq !== 'undefined') {
                    _paq.push([
                        'trackEvent',
                        'Formular',
                        'Bestellung service',
                        window.location.pathname.split('/').filter(Boolean).shift() || false,
                        !json.success ? 0 : 1
                    ]);
                }
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_gal_order_service_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    );
            },
            complete: function() {
                $('.loading').prop('hidden', true);
                $form.find(".btn[type=submit]").prop("disabled", false);
                $form.find(".btn-upload").prop("disabled", false).removeClass('disabled');
            }
        });

        return false;
    });
})(jQuery)